export default function getClerkKey() {
    if (process.env.NODE_ENV === 'development') {
       
        return 'pk_test_cHJvdmVuLWR1Y2tsaW5nLTc0LmNsZXJrLmFjY291bnRzLmRldiQ';
    }
    return "pk_live_Y2xlcmsuZWRkeS1lZHVjYXMuZGUk";
}